module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'auto-dict/base' && templateVars.config ?
				templateVars.config :
				{
	"container": "#container",
	"terms": {
		"ru": [
			{
				"term": "тем(ы|а)",
				"description": "это тема"
			},
			{
				"term": "аэрофлот",
				"description": "это компания"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/auto-dict/.variant/base/config.yaml
// module id = 156
// module chunks = 0